/**
 * <CanvasLoading/>
 * This component displays loading screen
 */
import { type FC } from "react";

import { LoadingScreen } from "~/components/common/loading/LoadingScreen";

export const CanvasLoading: FC = () => {
	return (
		<div className="h-full w-full">
			<LoadingScreen />
		</div>
	);
};
